//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';

import { RequestType } from '../../../types/enums/request-enums';

const GetCountryRateLimit = (params: any) =>
    request({
        url: ApiURL.Query.GetCountryRateLimit,
        method: RequestType.GET,
        params,
    });

const GetRequestLogs = (params: any) =>
    request({
        url: ApiURL.Query.GetRequestLogs,
        method: RequestType.GET,
        params,
    });

const GetRateLimitHistory = (params: any) =>
    request({
        url: ApiURL.Query.GetRateLimitHistory,
        method: RequestType.GET,
        params,
    });

const OtpPasswordQuery = {
    GetCountryRateLimit,
    GetRequestLogs,
    GetRateLimitHistory,
};

export default OtpPasswordQuery;
